/**
 * Purchase Service
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PurchaseOrderItemResultDTO } from './purchaseOrderItemResultDTO';
import { VendorVO } from './vendorVO';
import { PurchaseRequest } from './purchaseRequest';


export interface PurchaseOrderResultDTO { 
    id?: number;
    purchaseRequest?: PurchaseRequest;
    series?: string;
    vendorCode?: string;
    vendor?: VendorVO;
    postingDate?: string;
    deliveryDate?: string;
    description?: string;
    status?: PurchaseOrderResultDTO.StatusEnum;
    deleteFlag?: boolean;
    creationDate?: string;
    lastUpdateDate?: string;
    createdBy?: string;
    lastUpdatedBy?: string;
    objectVersionNumber?: number;
    items?: Array<PurchaseOrderItemResultDTO>;
}
export namespace PurchaseOrderResultDTO {
    export const StatusEnum = {
        Pending: 'PENDING',
        Approved: 'APPROVED',
        Rejected: 'REJECTED',
        Sent: 'SENT',
        VendorConfirmed: 'VENDOR_CONFIRMED',
        Delivered: 'DELIVERED',
        Done: 'DONE',
        Closed: 'CLOSED',
        Cancelled: 'CANCELLED'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
}


